/* Kalis
* To use this module to make every link that ends in #newtab open in a new tab. Used in main menu.
 */
(function init() {
  let $elements;
  $('.site-nav a').each((index, element) => {
    if ($(element).attr('href').endsWith('#newtab')) {
      $(element).attr('target', '_blank');
    }
  });
})();

